
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { permissionError, warning } from "../../../util/Alert";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import Table from "../../extra/Table";
import { deleteDelivery, getDelivery, toggleDeliveryStatus } from "../../store/deliveryService/delivery.action";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import DeliveryDialog from "./DeliveryDialog";

import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { usePermission } from "../../../hooks/usePermission";
import Iconb from "../../extra/Iconb";
import ToggleSwitch from "../../extra/ToggleSwitch";



const DeliveryService = () => {

    const { can } = usePermission();
    const canCreate = can("Setting", "Create");
    const canEdit = can("Setting", "Edit");
    const canDelete = can("Setting", "Delete");


    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [rowsPerPage, setRowsPerPage] = useState(10);

    const dispatch = useDispatch();

    const { delivery } = useSelector((state) => state.delivery);
    const { dialogue, dialogueType, dialogueData } = useSelector(
        (state) => state.dialogue
    );

    const hasPermission = useSelector((state) => state.admin.admin.flag);

    useEffect(() => {
        dispatch(getDelivery(page * rowsPerPage, rowsPerPage));
    }, [dispatch, page, rowsPerPage]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1500); // Adjust the delay time as needed

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        setData(delivery);
    }, [delivery]);

    // // pagination
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        dispatch(getDelivery(newPage * rowsPerPage, rowsPerPage));
    };

    const handleChangeRowsPerPage = (event) => {
        // setRowsPerPage(parseInt(event, 10));
        // setPage(0);
        const limit = parseInt(event, 10);
        setRowsPerPage(limit);
        setPage(0);
        dispatch(getDelivery(0, limit));
    };

    const handleClick = (deliveryDetail) => {
        if (!hasPermission) return permissionError();

        dispatch(
            toggleDeliveryStatus(
                deliveryDetail,
                deliveryDetail?.isActive === true ? false : true
            )
        );
    };

    // Delete bank
    const handleDelete = (id) => {
        warning("Delete")
            .then((isDeleted) => {
                if (!isDeleted) return;
                if (!hasPermission) return permissionError();
                dispatch(deleteDelivery(id));
            })
            .catch((err) => console.log(err));
    };

    const mapData = [
        {
            Header: "No",
            width: "20px",
            Cell: ({ index }) => <span className="text-white fw-normal">{page * rowsPerPage + parseInt(index) + 1}</span>,
        },

        {
            Header: "Delivery Name",
            body: "name",
            Cell: ({ row }) => <span className="text-white">{row?.name}</span>,
        },

        {
            Header: "Created Date",
            body: "createdAt",
            Cell: ({ row }) => (
                <span className="text-white">{dayjs(row.createdAt).format("DD MMM YYYY")}</span>
            ),
        },

        ...(canEdit ? [
            {
                Header: "is Active",
                body: "isActive",
                Cell: ({ row }) => (
                    <>
                        <div className="boxCenter">
                            <ToggleSwitch
                                value={row?.isActive}
                                onClick={() => handleClick(row)}
                            />
                        </div>
                    </>
                ),
            }
        ] : []),

        ...(canEdit ? [
            {
                Header: "Edit",
                body: "",
                Cell: ({ row }) => (
                    <>
                        <Iconb
                            newClass={`themeFont boxCenter infobtn userBtn fs-5`}
                            btnIcon={<CreateOutlinedIcon sx={{ color: '#737272' }} />}
                            style={{
                                borderRadius: "50px",
                                margin: "auto",
                                height: "45px",
                                width: "45px",
                                color: "#160d98",


                            }}
                            isImage={true}
                            onClick={() =>
                                dispatch({
                                    type: OPEN_DIALOGUE,
                                    payload: { data: row, type: "delivery" },
                                })
                            }

                        />
                        {dialogue && dialogueType === "bank" && <DeliveryDialog />}
                    </>
                ),
            }
        ] : []),

        ...(canDelete ? [
            {
                Header: "Delete",
                body: "",
                Cell: ({ row }) => (
                    <>
                        <Iconb
                            newClass={`themeFont boxCenter killbtn userBtn fs-5`}
                            btnIcon={<DeleteIcon sx={{ color: '#FF4C51' }} />}
                            style={{
                                borderRadius: "50px",
                                margin: "auto",
                                height: "45px",
                                width: "45px",
                                color: "#160d98",

                                padding: "0px"

                            }}
                            isImage={true}
                            isDeleted={true}
                            onClick={() => handleDelete(row?._id)}

                        />
                    </>
                ),
            }
        ] : [])


        // add more columns as needed
    ];
    return (
        <>
            <div className="mainSellerTable">
                <div className="sellerTable">

                    <div className="col-12 headname" >Delivery Service</div>
                    <div className="sellerMain">
                        <div className="tableMain mt-2">
                            <div className="sellerHeader primeHeader">
                                <div className="row">
                                    <div className="col-10">
                                        {canCreate && (
                                            <Button
                                                newClass={`whiteFont`}
                                                btnColor={`btnBlackPrime`}
                                                btnIcon={`fa-solid fa-plus`}
                                                btnName={`Add`}
                                                onClick={() => {
                                                    dispatch({
                                                        type: OPEN_DIALOGUE,
                                                        payload: { type: "delivery" },
                                                    });
                                                }}
                                                style={{ borderRadius: "5px", padding: "8px 32px", background: "#b93160" }}
                                            />
                                        )}
                                        {dialogue && dialogueType === "delivery" && <DeliveryDialog />}
                                    </div>
                                    <div className="col-2 text-end"></div>
                                </div>
                            </div>
                            <Table
                                data={data}
                                mapData={mapData}
                                PerPage={rowsPerPage}
                                Page={page}
                                type={"client"}
                                loading={loading}
                                shimmer={true}
                            />
                            <Pagination
                                component="div"
                                count={delivery?.length}
                                serverPage={page}
                                type={"client"}
                                onPageChange={handleChangePage}
                                serverPerPage={rowsPerPage}
                                totalData={delivery?.length}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </div>
                    </div>
                    <div className="sellerFooter primeFooter"></div>
                </div>
            </div>
        </>
    );
};

export default DeliveryService;
